/**
 * Predmemorija „Moj dan” za rad bez mreže (zadnje uspješno učitani podaci za datum).
 * Rezervna kopija u localStorageu, uvijek vezana uz scope `company_id:user_id:verzija-prava` (SEC-01).
 */

const PREFIX = 'zoma_myday_v2|';
const LEGACY_PREFIX = 'zoma_myday_v1_';
const key = (scope: string, dateYmd: string) => `${PREFIX}${scope}|${dateYmd}`;

/** Rok čuvanja predmemorije „Moj dan”. */
export const MYDAY_TTL_MS = 3 * 24 * 60 * 60 * 1000;

export interface MyDaySnapshot {
  scope: string;
  route: unknown;
  activeVisit: unknown;
  completedToday: number;
  savedAt: string;
}

export function isMyDaySnapshotValid(snap: unknown, scope: string, now = Date.now()): snap is MyDaySnapshot {
  const s = snap as MyDaySnapshot | null;
  if (!s || typeof s !== 'object' || s.scope !== scope || typeof s.completedToday !== 'number') return false;
  const saved = Date.parse(s.savedAt);
  return Number.isFinite(saved) && now - saved <= MYDAY_TTL_MS && saved <= now + 60_000;
}

export function saveMyDaySnapshot(dateYmd: string, snap: MyDaySnapshot): void {
  try {
    localStorage.setItem(key(snap.scope, dateYmd), JSON.stringify(snap));
  } catch {
    /* quota / private mode */
  }
}

export function loadMyDaySnapshot(scope: string, dateYmd: string): MyDaySnapshot | null {
  try {
    const raw = localStorage.getItem(key(scope, dateYmd));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return isMyDaySnapshotValid(parsed, scope) ? parsed : null;
  } catch {
    return null;
  }
}

function localKeys(): string[] {
  const out: string[] = [];
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k) out.push(k);
    }
  } catch { /* nedostupno */ }
  return out;
}

/** Briše stare zapise bez vlasnika i zapise starije od roka čuvanja. */
export function purgeLegacyAndExpiredMyDaySnapshots(now = Date.now()): void {
  for (const k of localKeys()) {
    if (k.startsWith(LEGACY_PREFIX)) {
      try { localStorage.removeItem(k); } catch { /* nedostupno */ }
      continue;
    }
    if (!k.startsWith(PREFIX)) continue;
    const scope = k.slice(PREFIX.length).split('|').slice(0, -1).join('|');
    let valid = false;
    try { valid = isMyDaySnapshotValid(JSON.parse(localStorage.getItem(k) || 'null'), scope, now); } catch { valid = false; }
    if (!valid) {
      try { localStorage.removeItem(k); } catch { /* nedostupno */ }
    }
  }
}

/** Odjava: ukloni sve „Moj dan” kopije s uređaja. */
export function clearAllMyDaySnapshots(): void {
  for (const k of localKeys()) {
    if (k.startsWith(PREFIX) || k.startsWith(LEGACY_PREFIX)) {
      try { localStorage.removeItem(k); } catch { /* nedostupno */ }
    }
  }
}
